import actions from './actions'
import getters from './getters'
import mutations from './mutations'

const state = {
  accounts: [],
  account_status: {},
  account: {},
  deletedAccount: null,
  pixelTrackingDetails: null,
  trackingDebugKey: null
}

export default {
  namespaced: true,
  state,
  actions,
  getters,
  mutations
}
